import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M25 4.096a16.66 16.66 0 0 0-5-.763C10.795 3.333 3.333 10.795 3.333 20c0 9.205 7.462 16.667 16.667 16.667 9.204 0 16.666-7.462 16.666-16.667 0-2.859-.72-5.55-1.988-7.9m-6.345-2.517h.008M17.5 36.48v-3.672c0-.199.071-.391.2-.542l4.143-4.834a.833.833 0 0 0-.219-1.265l-4.76-2.72a.834.834 0 0 1-.31-.311l-3.104-5.438a.833.833 0 0 0-.797-.417l-9.213.82M35 10c0 3.682-3.334 6.667-6.667 10-3.333-3.333-6.667-6.318-6.667-10A6.667 6.667 0 0 1 35 10zm-6.25-.417a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }